module.exports = __webpack_public_path__ + "static/media/explosive_arrow.257df181.png";